import "antd/dist/antd.css";
import React, { useLayoutEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import Search from "./components/Search";
import ipConfig from "./ipConfig.json";
import Product from "./components/Product"
import Checkout from "./components/Checkout"
import Thanks  from "./components/Thanks"

export const config = {
  endpoint: `https://ranv-qkart.herokuapp.com/api/v1`,
};

export default function App(props) {
  const location = useLocation();
  // Scroll to top if path changes
  useLayoutEffect(() => {
    window && window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="App">

        <Switch>

          <Route  exact path="/">
            <Home />
          </Route>

          <Route exact path="/register">
            <Register/>
          </Route>

          <Route  exact path="/login">
            <Login />

          </Route>
          <Route exact path="/products">
            <Search/>
          </Route>

          <Route exact path="/checkout">
            <Checkout/>
          </Route>
          <Route exact path="/thanks">
            <Thanks/>
          </Route>

          <Route path="*">
          <Home />
        </Route>
        </Switch>

        {/* TODO: CRIO_TASK_MODULE_UNDERSTANDING_BASICS - To add route for /register */}

        {/* TODO: CRIO_TASK_MODULE_UNDERSTANDING_BASICS - To add route for /login */}


    </div>
  );
}
